import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from '../components/toast';
import { getDashboardInfo } from '../services/api';
import { getUserGroups } from '../utils';
import { useLoadingState } from '../hooks/useLoadingState';

export default function HRDashboardPage() {
  const navigate = useNavigate();
  const [setHrDashboardInfo] = useState(null);
  const { withLoading } = useLoadingState({
    minLoadingTime: 800, // Ensure users see the beautiful animations
  });

  useEffect(() => {
    const userGroups = getUserGroups();
    if (userGroups === null || !userGroups.includes('hr')) {
      navigate('/login', { replace: true });
      return;
    }

    // Use the withLoading wrapper for automatic loading state management
    withLoading(
      async () => {
        const response = await getDashboardInfo();
        setHrDashboardInfo(response.data.info);
        return response.data.info;
      },
      'Loading dashboard statistics...' // Custom loading message
    ).catch(() => {
      toast.error('Cannot get HR dashboard info, try again later.');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, withLoading]);

  return (
    <>
      <Helmet>
        <title>BillerBay Transmit | HR Dashboard</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              HR Dashboard
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Hi, {localStorage.getItem('username')}!
            </Typography>
          </Grid>

          <Grid container spacing={2} px={2} />
        </Grid>
      </Container>
    </>
  );
}
